import React from 'react';
import moment from 'moment';
import $ from '../../common/AjaxRequest';
import { Modal, Button, Spin } from 'antd';
import API_URL from '../../common/url';
import TableC from '../basicElement/TableC';
import jquery from 'jquery';

class PreviewModal extends React.Component {
    state = {
        visible: false,
        investigation: {},
        userDetail: {},
        data: [],
        user: {},
        loading: false,
    }

    loadData = userId => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryEnterpriseUserById,
            data: { userId },
            dataType: 'json',
            doneResult: data => {
                this.setState({
                    loading: false,
                    investigation: data.data.userInfo.user,
                    userDetail: data.data.userInfo.user.userDetail,
                    user: data.data.userInfo.user,
                    data: data.data.invInfo,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    show = userId => {
        this.setState({
            visible: true,
        }, () => {
            this.loadData(userId);
            jquery('.ant-modal-body')[0].scrollTo(0, 0);
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    getColumns = () => [{
        title: '项目编号',
        dataIndex: 'investigationCode',
        key: 'investigationCode',
        width: 90,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 160,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '中心编号',
        dataIndex: 'investigationSiteCode',
        key: 'investigationSiteCode',
        width: 85
    }, {
        title: '中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        width: 180
    }, {
        title: '区域',
        dataIndex: 'areaName',
        key: 'areaName',
        width: 90,
    }, {
        title: '城市',
        dataIndex: 'cityName',
        key: 'cityName',
        width: 90,
    }, {
        title: '项目领域',
        dataIndex: 'investigationAreaName',
        key: 'investigationAreaName',
        width: 120
    }, {
        title: '疾病',
        dataIndex: 'diseaseName',
        key: 'diseaseName',
        width: 85
    }, {
        title: '领域leader',
        dataIndex: 'leaderNameCode',
        key: 'leaderNameCode',
        width: 100,
    }, {
        title: '研究产品类型',
        dataIndex: 'investigationMedicineName',
        key: 'investigationMedicineName',
        width: 120
    }, {
        title: '当月计划FTE',
        dataIndex: 'planFte',
        key: 'planFte',
        width: 85
    }]

    getDataSource = () => {
        const { data = [] } = this.state;
        const dataSource = data.map(item => ({
            id: item.user_role_investigation_site_id,
            planFte: item.plan_fte_sum,
            investigationCode: item.investigation_code,
            investigationName: item.investigation_name,
            investigationSiteName: item.investigation_site_name,
            investigationSiteCode: item.investigation_site_code,
            investigationMalady: item.investigation_malady,
            investigationMedicine: item.investigation_medicine,
            investigationAreaName: item.investigationAreaName || null,
            diseaseName: item.diseaseName || null,
            investigationMedicineName: item.investigationMedicineName || null,
            lineOfBusinessString: item.lineOfBusinessString || null,
            secondLineNames: item.secondLineNames || null,
            leaderNameCode: item.leaderNameCode,
            areaName: item.areaName,
            cityName: item.cityName,
        }));
        return dataSource;
    }


    render() {
        const { visible, loading, investigation, userDetail } = this.state;
        const {
            userCompellation,
            enterpriseDepartmentName,
            positionName,
            leaderName,
            userEmail,
            userMobile,
            cityName,
        } = investigation;
        const {
            employeeCode,
            joinTime,
            placeOfOriginA,
            workBeginTime,
            graduateTime,
            graduate,
            gender,
            subject,
            lastCompany,
            education,
        } = userDetail;
        return (
            <Modal
                title="人员信息"
                visible={visible}
                onCancel={this.hide}
                width={1000}
                maskClosable={false}
                confirmLoading={loading}
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <ul className="preview-list">
                        <li className="title preview-item"><h4>1.员工基本信息</h4></li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">工号</label>
                                <span className="ui-text">{employeeCode}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">姓名</label>
                                <span className="ui-text">{userCompellation}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">职位</label>
                                <span className="ui-text">{positionName}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">主管领导</label>
                                <span className="ui-text">{leaderName}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">部门</label>
                                <span className="ui-text">{enterpriseDepartmentName}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">工作地点</label>
                                <span className="ui-text">{cityName}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">入职时间</label>
                                <span className="ui-text">{moment(joinTime).format("YYYY-MM-DD")}</span>
                            </div>
                        </li>
                        <li className="title preview-item"><h4>2.联系方式</h4></li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">手机号码</label>
                                <span className="ui-text">{userMobile}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">邮箱</label>
                                <span className="ui-text">{userEmail}</span>
                            </div>
                            <div className="item">

                            </div>
                        </li>
                        <li className="title preview-item"><h4>3.个人信息</h4></li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">性别</label>
                                <span className="ui-text">{gender === 'MALE' ? '男' : '女'}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">籍贯</label>
                                <span className="ui-text">{placeOfOriginA}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">学历</label>
                                <span className="ui-text">{education}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">毕业院校</label>
                                <span className="ui-text">{graduate}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">专业</label>
                                <span className="ui-text">{subject}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">毕业时间</label>
                                <span className="ui-text">{graduateTime ? moment(graduateTime).format("YYYY-MM-DD") : ''}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">上家公司</label>
                                <span className="ui-text">{lastCompany}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">从事临床研究&nbsp;&nbsp;&nbsp;&nbsp;<br />起始时间</label>
                                <span className="ui-text">{workBeginTime ? moment(workBeginTime).format("YYYY-MM-DD") : ''}</span>
                            </div>
                        </li>
                        <li className="title preview-item"><h4>4.进行中项目</h4></li>
                        <li className="preview-item user-detail">
                            <TableC
                                columns={this.getColumns()}
                                data={this.getDataSource()}
                                scrollY={400}
                                className="userDetail"
                            />
                        </li>
                    </ul>
                </Spin>
            </Modal>
        );
    }
}

export default PreviewModal;



// WEBPACK FOOTER //
// ./src/components/user/PreviewModal.js